
import allMenu from './menus'
import allRoles from '../roles' 
import allTasks from './tasks'
// const pageRoutes = [
//   // { path: '/DetailTask/:id', component: DetailTask },
// ]

Tyan.setMenus(allMenu, allRoles, allTasks/* , pageRoutes */)
